<template>
  <div class="login">   
<el-card class="box-card">
<el-descriptions title="通知" direction="vertical" :column="4" border>
<el-descriptions-item :label="title">
  <el-date-picker
      v-model="datetime"
      type="date"
      value-format="yyyy-MM-dd"
      @change="getData"
      placeholder="选择日期">
    </el-date-picker>
  <div style="text-align: left;"></div>
  <span style="text-align: left;">未签到：{{unSignUsers}}</span>
  <el-table
    :data="tableData"
    border
    style="width: 100%;margin-top:10px">
    <el-table-column
      prop="order"
      label="序号"
      width="80">
    </el-table-column>
    <el-table-column
      prop="name"
      label="姓名"
      >
    </el-table-column>
    <el-table-column
      fixed="right"
      label="操作"
      width="100">
      <template slot-scope="scope">
        <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">签到</el-button> -->
        <el-checkbox @change="handleClick(scope.row)" v-model="scope.row.checked">签到</el-checkbox>
      </template>
    </el-table-column>
  </el-table></el-descriptions-item>
</el-descriptions>
</el-card>
    
  </div>
</template>

<script>
// 局部引入
export default {
  name: "App",
  data() {
    return {
      // 表格数据
      tableData: [],
      title:"",
      datetime:undefined,
      unSignUsers:""
    };
  },

  created: function () {
    this.getData(this.datetime)
  },
  mounted() {
    var that = this;

  },
  methods: {
    handleClick(row){
      var that = this;
      if(row.checked){
        this.axios
        .post("/Notice/UserSign",{datetime:this.datetime,userName:row.name})
        .then((response)=>{
            if (response.status == 200) {
            if (response.data.state == 0) {
                that.getData(that.datetime)
            } else {
              that.$message.error(response.data.message);
            }
          } else {
            that.$message.error("请检查网络设置");
          }
        })
      }else{
        this.axios
        .post("/Notice/UserUnSign",{datetime:this.datetime,userName:row.name})
        .then((response)=>{
            if (response.status == 200) {
            if (response.data.state == 0) {
                that.getData(that.datetime)
            } else {
              that.$message.error(response.data.message);
            }
          } else {
            that.$message.error("请检查网络设置");
          }
        })
      }
      
    },
    getData(datetime){
      var that = this;
      this.axios
        .post("/Notice/GetNotice",{datetime:datetime})
        .then((response)=>{
            if (response.status == 200) {
            if (response.data.state == 0) {
                this.title=response.data.data.title
                this.datetime=response.data.data.createTime
                this.unSignUsers=response.data.data.unSignUsers
                var i=1;
                var data=response.data.data.users.split(',').map(d=>{
                    i++
                    var checked=false
                    if(this.unSignUsers.indexOf(d)<0){
                      checked=true
                    }
                    return {order:i,name:d,checked:checked}
                })
                Promise.all(data).then((res)=>{
                    this.tableData=res
                    console.log(this.tableData)
                })

            } else {
              that.$message.error(response.data.message);
            }
          } else {
            that.$message.error("请检查网络设置");
          }
        })
    }
  },
};
</script>
<style scoped>
/* .login {
  width: 100%;
  height: 100%;
  background: url(../../assets/bg.png) no-repeat;
  background-size: cover;

  z-index: -10;
} */
</style>


// WEBPACK FOOTER //
// src/components/Notice/Index.vue